<ul class="pages-tabs {{customClass}}">
    <li *ngFor="let item of applicationFileData" class="page-item {{item.isActive ? 'active' : ''}}"
        [ngClass]="{'has-determinants': hasDeterminants(item?.form?.jsonDeterminants)}">
        <a *ngIf="item.form && (item.form.showTab == null || item.form.showTab)" class="page-tab-link"
            routerLink="{{item.link}}">
            {{item.translation | translate}}
        </a>
        <span *ngIf="item.form && (item.form.showTab == null  || item.form.showTab) && item.showActiveToggle"
            class="form-activator">
            <i *ngIf="item.form && item.form.active != null" (click)="toggleForm(item)"
                class="page-tab-toggle fa-circle"
                [ngClass]="{'fa-solid toggle-off': !item.form.active, 'fa-regular toggle-on': item.form.active}"></i>
            <i *ngIf="!item.form || item.form.active == null" class="fa-regular fa-sync-alt fa-spin loading"></i>
        </span>
        <span *ngIf="debugMode && item.form && getErrorsForForm(item.form.id) > 0"
            class="badge badge-danger mr-3 cursor-pointer"
            style="font-size: 0.7em;"
            tooltip="{{'Form has errors detected by dry-run' | translate}}"
            container="body" placement="bottom"
            (click)="onBadgeClick(item.form.id, item.translation); $event.stopPropagation(); $event.preventDefault();">
            {{ getErrorsForForm(item.form.id) }}
        </span>
        <span *ngIf="item.form && hasDeterminants(item.form.jsonDeterminants)"
            class="btn-circle-extra-small btn-circle-icon btn-warning mr-3 font-weight-bold active"
            tooltip="{{determinantMapById != null && item?.form?.jsonDeterminants !== null ? roleDeterminants(item?.form?.jsonDeterminants) : ''}}"
            container="body" placement="bottom">
            D
        </span>
    </li>
</ul>